/**
 * BreadcrumbList structured data (JSON-LD) for SEO
 * Improves navigation understanding for search engines
 * Follows Schema.org BreadcrumbList specification
 */

import React from 'react';
import { JSONLDScript } from './jsonld-script';

export interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbStructuredDataProps {
  items: BreadcrumbItem[];
}

export function BreadcrumbStructuredData({ items }: BreadcrumbStructuredDataProps) {
  const baseUrl =
    process.env.NEXT_PUBLIC_APP_URL || process.env.APP_URL || 'https://emailferret.io';

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url.startsWith('http') ? item.url : `${baseUrl}${item.url}`,
    })),
  };

  return <JSONLDScript data={breadcrumbSchema} id="breadcrumb-structured-data" />;
}
